import { render, staticRenderFns } from "./PublishContent.vue?vue&type=template&id=66dbc8ee"
import script from "./PublishContent.vue?vue&type=script&lang=js"
export * from "./PublishContent.vue?vue&type=script&lang=js"
import style0 from "./PublishContent.vue?vue&type=style&index=0&id=66dbc8ee&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports